function CobBucks(props) {
    return (
    <>
      <div className="regularCard">
          <h4 className="cardTitle">{props.name}</h4>
          <img className="Bucksimage" src={props.image} alt={props.name} />
        <div className="cardSide">
          <center>{props.amount}</center>
        </div>
      </div>
      
    </>
    );
  }
  
  export default CobBucks;